<template>
  <div>
    <div class="box">
      <div class="columns">
        <div class="column is-half">
          <p class="subtitle p-t-sm">Didn't find the answer to your question?</p>
          <button class="button is-primary is-medium">
            <span>
              <i class="fas fa-plus"></i>
            </span>Add question
          </button>
        </div>
        <div class="column is-half">
          <div class="field has-addons has-addons-right">
            <div class="control">
              <input class="input" type="text" placeholder="Find a quesetion">
            </div>
            <div class="control">
              <a class="button is-link">
                Search
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-for="(question, index) in questions" v-bind:key="index" class="box question-box">
      <div class="columns">
        <div class="column is-three-fifths">
          <a href="">
            <p class="title is-5 faq-title">
              <strong>{{ question.body }}</strong>
            </p>
          </a>
          <p class="subtitle is-6">Added on {{ question.date }} by
            <a href="">@{{ question.author }}</a>
          </p>
        </div>
        <div class="column is-two-fifths has-text-right">
          <p>Tags:</p>
          <div class="level-right tags">
            <span v-for="(tag, index) in question.tags" v-bind:key="index" class="tag">
              <a href="">#{{ tag }}</a>
            </span>
          </div>
        </div>
      </div>
    </div>

    <nav class="pagination is-centered" role="navigation" aria-label="pagination">
      <a class="pagination-previous">Previous</a>
      <a class="pagination-next">Next page</a>
      <ul class="pagination-list">
        <li>
          <a class="pagination-link" aria-label="Goto page 1">1</a>
        </li>
        <li>
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li>
          <a class="pagination-link" aria-label="Goto page 10">10</a>
        </li>
        <li>
          <a class="pagination-link is-current" aria-label="Page 11" aria-current="page">11</a>
        </li>
        <li>
          <a class="pagination-link" aria-label="Goto page 12">12</a>
        </li>
        <li>
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li>
          <a class="pagination-link" aria-label="Goto page 20">20</a>
        </li>
      </ul>
    </nav>
  </div>
</template>


<script>

export default {
  data() {
    return {
      questions: [
        {
          body: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua?',
          date: '16/03/2018',
          author: 'awesomewriter',
          tags: ['TagOne', 'TagTwo', 'TagThree', 'TagFour'],
        },
        {
          body: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?',
          date: '12/11/2018',
          author: 'ana smith',
          tags: ['TagOne', 'TagTwo', 'TagThree', 'TagFour', 'TagFive'],
        },
        {
          body: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum?',
          date: '16/03/2018',
          author: 'john doe',
          tags: ['TagOne', 'TagTwo', 'TagThree', 'TagFive'],
        },
        {
          body: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua?',
          date: '16/03/2018',
          author: 'awesomewriter',
          tags: ['TagOne', 'TagTwo', 'TagThree', 'TagFour'],
        },
      ],
    };
  },
};
</script>

<style>
.tag a {
  color: black;
}

.faq-title {
  /*color: #00d1b2;*/
}

.box.question-box {
  margin-bottom: 0.5rem;
}
a {
  color: #3273dc;
}
</style>
